<template>
    <form :action="`/desk-audits/${deskAudit.id}`" method="post" @submit.prevent="save()">
        <button type="submit" class="btn btn-danger btn-sm">Remove Desk Audit</button>
    </form>
</template>
<script>
export default {
    props: {
        deskAudit: {
            required: true,
            type: Object,
        }
    },

    methods: {
        save() {
            let response = confirm("Are you sure about deleting this desk audit?");
            if (!response) return;

            App.request().delete(`/desk-audits/${this.deskAudit.id}`)
                .then(response => {
                    this.redirectTo('/desk-audits')
                })
                .catch(errors => {
                    console.log(errors)
                    Alert.error(errors.first())
                })
        }
    }
}
</script>
